<div *ngIf="isLoading$" class="loading-root">
    <div [ngClass]="{ 'full-page-loading': !displayInline }" *ngIf="isLoading$ | async">
      <div class="loading">
        <div class="loading-spinner">
          <div class="loading-inner"></div>
        </div>
      </div>
      <img src="https://hub.aaos.org/intranet/EmployeeDirectory/EmployeePics/IMG_1129%20%282%29_edited2.jpg" class="rotate" width="100" height="100" />
    </div>
  </div>
  <div *ngIf="isLoading !== null" class="loading-root">
    <div [ngClass]="{ 'full-page-loading': !displayInline }" *ngIf="isLoading">
      <div class="loading">
        <div class="loading-spinner">
          <img src="https://hub.aaos.org/intranet/EmployeeDirectory/EmployeePics/IMG_1129%20%282%29_edited2.jpg" class="rotate" width="100" height="100" />
        </div>
      </div>
    </div>
  </div>
  